const baseAdvertUrl = "Advert"


  const endpoints = {
   getAdvertList:`${baseAdvertUrl}/List`,
   deleteAdvertList:`${baseAdvertUrl}`,
   removeFromPublication:`${baseAdvertUrl}/RemovePublish`,
   publishAdvert:`${baseAdvertUrl}/AddPublish`,
   saveFilter:`${baseAdvertUrl}/SaveFilter`,
   
   
  };
  
  export default endpoints;
  